import { css } from '@emotion/react';

export type Color = keyof typeof colors;

export const brandColors = {
  black: '#121318',
  petrol: '#326B5E',
  yellow: '#FFEB46',
  red: '#FF5452',
  blue: '#6F8BE9',
  green: '#43ce78',
  brown: '#7D6D54',
  peach: '#FBCC9D',
};

const functionalColors = {
  error: '#FF6652',
  info: '#6F8BE9',
  success: '#43ce78',
  warning: '#FF9333',
};

const accentTintColors = {
  yellowLight: '#FFF9C6',
  yellowDark: '#FDDA40',
  blueLighter: '#E8EBFB',
  blueLight: '#9BACEF',
  blueDark: '#104FCE',
  blueDarker: '#003AB5',
  greenDark: '#00A148',
};

export const colors = {
  ...brandColors,
  ...functionalColors,
  ...accentTintColors,
  lightBlue: '#70AFD9',
  lightGreen: '#94dc9e',
  white: '#ffffff',
  grey: '#ACB5BD',
  gray: '#ACB5BD',
  darkGrey: '#656873',
  darkGray: '#656873',
  lightGrey: '#E6EBEF',
  lightGray: '#E6EBEF',
  brightGrey: '#F9FAFB',
  brightGray: '#F9FAFB',
  lightRed: '#FAE8E8',
};

export const breakpointValues = {
  tablet: 768,
  desktop: 1025,
  xl: 1440,
};

// TODO: Update with breakpoints from design
export const breakpointQueries = {
  tablet: `(min-width:${breakpointValues.tablet}px)`,
  desktop: `(min-width:${breakpointValues.desktop}px)`,
  xl: `(min-width:${breakpointValues.xl}px)`,
};

export const breakpoints = {
  tablet: `@media ${breakpointQueries.tablet}`,
  desktop: `@media ${breakpointQueries.desktop}`,
  xl: `@media ${breakpointQueries.xl}`,
};

// index:               0  1  2   3   4   5   6   7   8   9   10  11
export const spacing = [4, 8, 12, 16, 24, 32, 40, 48, 56, 64, 80, 120];

export const NAVBAR_HEIGHT_S = 56;
export const NAVBAR_HEIGHT_L = 80;

const DESKTOP_SECTION_MIN_HEIGHT = 720;
export const DESKTOP_SECTION_MIN_HEIGHT_CSS = css`
  ${breakpoints.desktop} {
    min-height: ${DESKTOP_SECTION_MIN_HEIGHT}px;
  }
`;
export const DESKTOP_SECTION_FIXED_HEIGHT_CSS = css`
  ${breakpoints.desktop} {
    height: ${DESKTOP_SECTION_MIN_HEIGHT}px;
  }
`;

export const zIndexes = {
  nav: 10,
  overlay: 20,
  modal: 30,
};
